export const ADMIN_URL = '/api/admin';
export const REACT_APP_BUSINESS_URL='https://records.4safedrivers.com';
//export const APP_BASE_URL= 'http://127.0.0.1:8000';
 export const APP_BASE_URL= '';